<template>
	<material-card icon="mdi-credit-card" icon-small title="10 تغییر آخر امضای دیجیتال" color="info" :loading="loading">
		<template v-slot:topActions>
			<v-btn text small color="secondary" v-if="area === 'admin'" @click="routeToDigitalSignContractsReport">مشاهده همه</v-btn>
			<v-btn icon @click="loadData()">
				<v-icon>mdi-refresh</v-icon>
			</v-btn>
		</template>
		<v-card-text style="min-height: 205px;overflow: hidden;">
			<v-data-table hide-default-footer :headers="headers" height="175" dense :items="items" :items-per-page="15" class="elevation-1">
				<template v-slot:item="row">
					<tr>
						<td>
							<div @click="manageLoanRequest(row.item)" style="cursor:pointer">
								<div class="grey--text d-flex flex-wrap" style="column-gap: 15px;">
									<small class="info--text">شماره درخواست: {{ row.item.code }}</small>
									<small class="">({{ row.item.title }})</small>
									<small class="">تاریخ درخواست: {{ row.item.date }}</small>
									<small class="">مبلغ: {{ row.item.amount.toString().toPriceFormat() }}</small>
									<small class="">مشتری: {{ row.item.fullName }}</small>
									<small class="">نماینده: {{ row.item.agentBusinessName || 'ندارد' }}</small>
								</div>
							</div>
						</td>
						<td class="text-center">
							<small>
								{{ row.item.str_Status }}
							</small>
						</td>
					</tr>
				</template>
			</v-data-table>
		</v-card-text>

		<v-dialog v-model="dialogModifyRequest" scrollable persistent max-width="1100px">
			<modify-request ref="modifyRequest" v-if="dialogModifyRequest" :data="selectedLoanRequest" @close="dialogModifyRequest = false" />
		</v-dialog>

	</material-card>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import _ from 'lodash'
import router from '@/router'

export default {
	name: 'LatestDigitalSignContractsWidget',
	props: {
		area: { type: String },
	},
	components: {
		'modify-request': () => import('@/views/admin/ModifyLoanRequest.vue'),
	},
	data() {
		return {
			dialogModifyRequest: false,
			errorMessages: '',
			selectedLoanRequest: {},
			loading: false,
			headers: [
				{
					text: 'شماره درخواست',
					align: 'center',
					sortable: true,
					value: 'code',
				}, {
					text: 'مشتری',
					align: 'start d-none',
					sortable: true,
					value: 'fullName',
					width: '200'
				}, {
					text: 'نماینده',
					align: 'start d-none',
					sortable: true,
					value: 'agentBusinessName',
					width: '150'
				}, {
					text: 'عنوان وام',
					align: 'start d-none',
					sortable: true,
					value: 'title',
					width: '250'
				}, {
					text: 'کد ملی',
					align: ' d-none',
					sortable: true,
					value: 'nationalCode',
				}, {
					text: 'مبلغ وام',
					align: 'center d-none',
					sortable: true,
					value: 'amount',
				}, {
					text: 'تاریخ تغییر',
					align: 'center d-none',
					sortable: true,
					value: 'date',
				}, {
					text: 'وضعیت',
					align: 'center',
					sortable: true,
					value: 'str_Status',
					// width: '150'
				},
			],
			items: [],
		}
	},
	mounted() {
		this.loadData()
	},
	computed: {

	},
	methods: {
		manageLoanRequest(item) {
			if (this.area !== 'admin')
				return
			this.selectedLoanRequest = {
				id: item.id,
			}
			this.dialogModifyRequest = true
		},
		loadData() {
			this.loading = true
			api.get(`${this.area}/dashboard/GetDigitalSignContracts`, {})
				.then(
					response => {
						this.items = response
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.loading = false })
		},
		routeToDigitalSignContractsReport() {
			this.$router.push('/admin/digitalSignContracts').catch(() => { })
		}
	},
}
</script>
<style scoped></style>
